import React from 'react';


export default function Footer() {
return (
<footer id="contact" className="footer">
<div className="footer-inner">
<p>Made with React.js • <a href="https://github.com/jacobigo" target="_blank" rel="noreferrer">GitHub</a></p>
</div>
</footer>
);
}